<template>
    <SOSlotModal  
        :modal-title="title"
        :modal-id="id"
        :no-padding="true"
        @close="decline()"
    >
        <template v-slot:modal-body>
            <div :class="{'p-4': !isDenseBody}">
                <slot name="body" v-if="$slots.body"></slot>
                <div v-else>
                    {{ body }}
                </div>
            </div>
        </template>
        <template v-slot:modal-footer v-if="!isHideFooter">
            <div id="button" class="px-4 pb-2">
                <SOButton
                    :outline="outline"
                    :text="buttonText"
                    :primary="primary"
                    :outline-danger="outlineDanger"
                    :disable="disable"
                    :loading="loading"
                    :full="true"
                    @action="confirm()"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "confirmModal",
    components: {
        SOSlotModal,
        SOButton,
    },
    props: {
        title: {
            type: String,
            default: "Konfirmasi",
        },
        isDenseBody: {
            type: Boolean,
            default: false,
        },
        isHideFooter: {
            type: Boolean,
            default: false,
        },
        body: {
            type: String,
            default: "Yakin ingin melakukan aksi?",
        },
        buttonText: {
            type: String,
            default: 'Ya, Konfirmasi'
        },
        primary: {
            type: Boolean,
            default: true
        },
        danger: {
            type: Boolean,
            default: false
        },
        outline: {
            type: Boolean,
            default: false
        },
        outlineDanger: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            id:"confirm-modal",
            requestChange: null,
            resolve: null,
        }
    },
    methods: {
        open() {
            return new Promise((resolve)=>{
                this.resolve = resolve
                $("#" + this.id).modal("show");
            })
        },
        confirm() {
            console.log('acc');
            this.resolve(true)
        },
        decline() {
            this.resolve(false)
            this.close();
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
    },
}
</script>

<style scoped>
#button >>> .btn-outline-danger{
    margin-bottom: 1rem
}
</style>